import type { MonthlyNetSalesReportState } from './MonthlyNetSalesReportState';
import { initialMonthlyNetSalesReportState } from './MonthlyNetSalesReportState';
import {
    MONTHLY_NET_SALES_REPORT_GET_ERROR,
    MONTHLY_NET_SALES_REPORT_GET_START,
    MONTHLY_NET_SALES_REPORT_GET_SUCCESS,
    type MonthlyNetSalesReportAction
} from 'actions/insights/sales/monthlyNetSalesReport/MonthlyNetSalesReportActionsTypes';

export const monthlyNetSalesReportReducer = (
    state: MonthlyNetSalesReportState = initialMonthlyNetSalesReportState,
    action: MonthlyNetSalesReportAction
): MonthlyNetSalesReportState => {
    switch (action.type) {
        case MONTHLY_NET_SALES_REPORT_GET_START:
            return { ...state, loading: true };
        case MONTHLY_NET_SALES_REPORT_GET_SUCCESS:
            return { ...state, loading: false, report: action.payload.report };
        case MONTHLY_NET_SALES_REPORT_GET_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
};
